import { IUserInRole } from 'pages/Login';
import { LoadState, SubmissionState } from './states';
import { OrderStatus, OrderType } from 'models/Order';

export const orderDefaultState = {
  aEHierarchyOptions: [],
  aeHierarchyLoadState: LoadState.IDLE,
  hierarchyOptions: [],
  hierarchyLoadState: LoadState.IDLE,
  showResultModal: false,
  submissionState: SubmissionState.IDLE,
  orderLoadState: LoadState.IDLE,
  feedbackOptions: [],
  readOnlyOrder: undefined,
};

export const getDefaultOrderModel = (currentUser: IUserInRole | undefined, urlSegments: string) => {
  const orderTypeValue = urlSegments.charAt(0).toUpperCase() + urlSegments.slice(1);

  return {
    id: undefined,
    orderNumber: '',
    customerName: '',
    customerUnit: undefined,
    customerContact: currentUser ? currentUser.name : '',
    customerContactPhone: '',
    customerContactEmail: currentUser && currentUser?.email ? currentUser?.email : '',
    orderType: Object.values(OrderType)[orderTypeValue],
    orderStatus: OrderStatus[0],
    createdDate: '',
    updatedDate: '',
    assignedUser: '',
    responsible: '',
    requestedPersonalNumber: '',
    requestedName: '',
    requestedEmail: '',
    requestedPhone: '',
    requestedHomeAddress: '',
    requestedBriefDesc: '',
    requestedAdditionalInformation: '',
    requestedNumberOfAttendees: 4,
    healthCenter: undefined,
    requestedDate: '',
    requestedDeliveryDateSpecification: { id: 'asap', name: 'As soon as possible' },
    digitalDelivery: '',
    smsConsent: false,
    bookingDate: '',
    bookingDetails: '',
    feedbackPerformed: undefined,
    feedbackRecipient: undefined,
    feedbackContactDetails: '',
    attachments: [],
    additionalHealthCenters: [],
  };
};
